import axios from 'axios';

export const API_BASE_URL = process.env.REACT_APP_LEADS_API_URL || 'http://localhost:8000/leads-finder';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 120000,
  headers: {
    'Content-Type': 'application/json',
    'ngrok-skip-browser-warning': 'true',
  },
});

// Attach the shared login's JWT (see AuthContext.jsx, which persists it to
// sessionStorage on login/logout) to every Lead Finder request. This
// instance is separate from the shared `API` instance in @/lib/api because
// it has its own baseURL (/leads-finder) - it never needed a token before
// because the backend's leads-finder routes previously accepted any/no
// caller (see SalesOS-Backend/leads_finder/routes/auth.py's security fix);
// now that they require a real login, this was the missing piece causing
// Lead Finder to show no data even while logged in.
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
